"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _types = require("../../actions/broadcast/types");
var _types2 = require("../../actions/stream/types");
var _types3 = require("../../actions/types/types.generic");
var _StreamStates = require("../../constants/StreamStates");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function streamEndpoints() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var type = action.type,
    payload = action.payload;
  if (["".concat(_types.GET_BROADCAST, "_SUCCESS"), "".concat(_types2.BROADCAST_STOP_STREAM, "_SUCCESS"), "".concat(_types2.BROADCAST_START_STREAM, "_SUCCESS"), "".concat(_types2.BROADCAST_SYNC_ENDPOINTS, "_SUCCESS"), "".concat(_types2.BROADCAST_START_STREAMS, "_SUCCESS"), "".concat(_types2.BROADCAST_STOP_STREAMS, "_SUCCESS")].includes(type)) {
    var endpoints = payload.endpoints;
    return endpoints;
  }
  if (type === _types3.RESET_BROADCAST_STREAM_START_FAILED_STATUS) {
    var _endpoints = payload.endpoints;
    return _endpoints.map(function (endpoint) {
      if (endpoint.status === _StreamStates.STREAM_START_FAILED) {
        delete endpoint.status;
        delete endpoint.error;
      }
      return endpoint;
    });
  }
  if (type === _types3.RESET_BROADCAST_STREAM_STOP_FAILED_STATUS) {
    var _endpoints2 = payload.endpoints;
    return _endpoints2.map(function (endpoint) {
      if (endpoint.status === _StreamStates.STREAM_STOP_FAILED) {
        delete endpoint.status;
      }
      return endpoint;
    });
  }
  if (type === "".concat(_types2.BROADCAST_GET_ENDPOINTS, "_SUCCESS")) {
    return payload;
  }

  // TEMP: This is to support backward compatibility for optimization changes on api.v2

  if (type === "".concat(_types2.BROADCAST_DELETE_STREAM_ENDPOINT, "_SUCCESS")) {
    var _endpoints3 = payload.endpoints;
    if (_endpoints3) {
      return _endpoints3;
    }
    var deletedEndpointId = payload;
    return state.filter(function (_ref) {
      var _id = _ref._id;
      return _id !== deletedEndpointId;
    });
  }
  if (type === "".concat(_types2.BROADCAST_CREATE_STREAM_ENDPOINT, "_SUCCESS")) {
    var _endpoints4 = payload.endpoints;
    if (_endpoints4) {
      return _endpoints4;
    }
    return [].concat(_toConsumableArray(state), [payload]);
  }
  if (type === "".concat(_types2.BROADCAST_UPDATE_STREAM_ENDPOINT, "_SUCCESS")) {
    var _endpoints5 = payload.endpoints;
    if (_endpoints5) {
      return _endpoints5;
    }
    return state.map(function (endpoint) {
      if (endpoint._id === payload._id) {
        return payload;
      }
      return endpoint;
    });
  }
  if (type === _types2.BROADCAST_UPDATE_STREAM_REALTIME) {
    var _endpoints6 = _toConsumableArray(state);
    var existingEndpoint = _endpoints6.find(function (_ref2) {
      var _id = _ref2._id;
      return _id === payload._id;
    });
    if (existingEndpoint) {
      _endpoints6 = _endpoints6.map(function (endpoint) {
        if (endpoint._id === payload._id) {
          // TaskId is the arn of the current ec2 task that is used for streaming.
          // If the tasKid is not present in the payload, that means the ec2 task has stopped,
          // it has to be deleted from current endpoint
          // The endpoint is updated by using the spread operator. It would keep the arn
          // of the now deleted ec2 task, if it is not deleted.

          if (!('taskId' in payload)) {
            delete existingEndpoint.taskId;
          }
          return _objectSpread(_objectSpread({}, existingEndpoint), payload);
        }
        return endpoint;
      });
    } else {
      _endpoints6 = [].concat(_toConsumableArray(_endpoints6), [payload]);
    }
    return _endpoints6;
  }
  if (type === _types2.BROADCAST_SET_TRANSIENT_STREAM_STATUS) {
    var status = payload.status,
      payLoadEndpoints = payload.endpoints;
    return state.map(function (endpoint) {
      var existingEndpoint = payLoadEndpoints.find(function (payloadEndpoint) {
        return payloadEndpoint === endpoint._id;
      });
      if (existingEndpoint !== undefined) {
        return _objectSpread(_objectSpread({}, endpoint), {}, {
          status: status
        });
      }
      return endpoint;
    });
  }
  function extractErrorInfo(payload) {
    var _payload$error, _payload$error2;
    var error = {
      isFailed: true,
      errorMessage: payload === null || payload === void 0 || (_payload$error = payload.error) === null || _payload$error === void 0 ? void 0 : _payload$error.message
    };
    var axiosErrorResponse = JSON.parse(payload === null || payload === void 0 || (_payload$error2 = payload.error) === null || _payload$error2 === void 0 || (_payload$error2 = _payload$error2.config) === null || _payload$error2 === void 0 ? void 0 : _payload$error2.data);
    return {
      error: error,
      axiosErrorResponse: axiosErrorResponse
    };
  }
  if (type === "".concat(_types2.BROADCAST_START_STREAM, "_FAILURE")) {
    var _extractErrorInfo = extractErrorInfo(payload),
      error = _extractErrorInfo.error,
      axiosErrorResponse = _extractErrorInfo.axiosErrorResponse;
    return state.map(function (endpoint) {
      var _axiosErrorResponse$p;
      if (endpoint._id === ((_axiosErrorResponse$p = axiosErrorResponse.params) === null || _axiosErrorResponse$p === void 0 ? void 0 : _axiosErrorResponse$p.endpointId)) {
        return _objectSpread(_objectSpread({}, endpoint), {}, {
          status: _StreamStates.STREAM_START_FAILED,
          error: error
        });
      }
      return endpoint;
    });
  }
  if (type === "".concat(_types2.BROADCAST_START_STREAMS, "_FAILURE")) {
    var _extractErrorInfo2 = extractErrorInfo(payload),
      _error = _extractErrorInfo2.error,
      _axiosErrorResponse = _extractErrorInfo2.axiosErrorResponse;
    return state.map(function (endpoint) {
      var _axiosErrorResponse$p2;
      if ((_axiosErrorResponse$p2 = _axiosErrorResponse.payload) !== null && _axiosErrorResponse$p2 !== void 0 && (_axiosErrorResponse$p2 = _axiosErrorResponse$p2.endpoints) !== null && _axiosErrorResponse$p2 !== void 0 && _axiosErrorResponse$p2.includes(endpoint._id)) {
        return _objectSpread(_objectSpread({}, endpoint), {}, {
          status: _StreamStates.STREAM_START_FAILED,
          error: _error
        });
      }
      return endpoint;
    });
  }
  if (type === "".concat(_types2.BROADCAST_STOP_STREAM, "_FAILURE") || type === "".concat(_types2.BROADCAST_STOP_STREAMS, "_FAILURE")) {
    var _extractErrorInfo3 = extractErrorInfo(payload),
      _error2 = _extractErrorInfo3.error,
      _axiosErrorResponse2 = _extractErrorInfo3.axiosErrorResponse;
    return state.map(function (endpoint) {
      var _axiosErrorResponse2$, _axiosErrorResponse2$2;
      if (type === "".concat(_types2.BROADCAST_STOP_STREAM, "_FAILURE") && endpoint._id === ((_axiosErrorResponse2$ = _axiosErrorResponse2.params) === null || _axiosErrorResponse2$ === void 0 ? void 0 : _axiosErrorResponse2$.endpointId) || type === "".concat(_types2.BROADCAST_STOP_STREAMS, "_FAILURE") && (_axiosErrorResponse2$2 = _axiosErrorResponse2.payload) !== null && _axiosErrorResponse2$2 !== void 0 && (_axiosErrorResponse2$2 = _axiosErrorResponse2$2.endpoints) !== null && _axiosErrorResponse2$2 !== void 0 && _axiosErrorResponse2$2.includes(endpoint._id)) {
        return _objectSpread(_objectSpread({}, endpoint), {}, {
          status: _StreamStates.STREAM_STOP_FAILED,
          error: _error2
        });
      }
      return endpoint;
    });
  }
  if (type === "".concat(_types2.BROADCAST_STOP_STREAMS, "_SUCCESS")) {
    return state.map(function (endpoint) {
      return _objectSpread(_objectSpread({}, endpoint), {}, {
        status: _StreamStates.STREAM_STOPPED
      });
    });
  }
  return state;
}
var _default = exports["default"] = streamEndpoints;